import { Injectable } from '@angular/core';
import { NetworkService } from './network.service';
import { EventsService } from './events.service';
import {
  PRODUCT_HAS_ADDED_TO_WISHLIST,
  PRODUCT_HAS_REMOVED_FROM_WISHLIST
} from '../../app.constants';
import { removeById } from '../../utils';

@Injectable()
export class WishListService {
  wishList = [];

  constructor(
    private networkService: NetworkService,
    private eventsService: EventsService
  ) {}


  activate() {
    this.networkService
      .fetchWishList()
      .then(response => {
        this.wishList.length = 0;
        response.forEach(item => {
          this.wishList.push(item);
        })
      });

    this.eventsService
      .on(PRODUCT_HAS_ADDED_TO_WISHLIST)
      .subscribe(this.addToWishList);

    this.eventsService
      .on(PRODUCT_HAS_REMOVED_FROM_WISHLIST)
      .subscribe(this.removeFromWishList);
  }

  isProductInTheWishList (id) {
    const index = this.wishList.findIndex(item => {
        return item.id === id;
    });
    return index > -1;
  }

  addToWishList(product) {
    this.networkService
      .addToWishList(product.id)
      .then(response => {
        this.wishList = response;
      });
  }

  removeFromWishList (product) {
    this.networkService
      .removeFromWishList(product.id)
      .then(() => {
        removeById(this.wishList, product.id);
      })
  }

  getWishList () {
    return this.wishList;
  }

  countItemsInWishList () {
    return this.wishList.length;
  }

  clear () {
    this.wishList.length = 0;
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/(IGH Projects)/jobs/EVFS PROD_FRONTEND granima.de/workspace/frontend/src/app/core/services/wish-list.service.ts